"use strict";
// ===========================================================================
// DO NOT EDIT THIS FILE MANUALLY!
//
// The contents have been added automatically.
// See: scripts/generate-dapps.ts for more information
// ===========================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAPPS = void 0;
exports.DAPPS = [
    { aliases: { apebank: { chains: ['apechain'], title: 'ApeBank' } }, homepageUrl: 'https://ape-bank.netlify.app/' },
    { aliases: { 'aurum-finance': { chains: ['sonic'], title: 'Aurum' } }, homepageUrl: 'https://aurumfi.io/' },
    {
        aliases: {
            'compound-finance-usde': {
                chains: ['mantle'],
                title: 'Compound Finance USDe market',
                description: 'Only to be used for the USDe market.',
            },
        },
        homepageUrl: 'https://compound.finance/',
    },
    { aliases: { dtrinity: { chains: ['fraxtal', 'sonic'], title: 'dTRINITY' } }, homepageUrl: 'https://dtrinity.org/' },
    { aliases: { elara: { chains: ['zircuit'], title: 'Elara' } }, homepageUrl: 'https://app.elara.finance/' },
    { aliases: { enclabs: { chains: ['sonic'], title: 'Enclabs' } }, homepageUrl: 'https://www.enclabs.finance/' },
    { aliases: { hana: { chains: ['taiko'], title: 'Hana Finance' } }, homepageUrl: 'https://www.hana.finance/' },
    { aliases: { init: { chains: ['blast', 'mantle'], title: 'INIT Capital' } }, homepageUrl: 'https://init.capital/' },
    {
        aliases: { ionic: { chains: ['mode', 'metal'], title: 'Ionic Protocol' } },
        homepageUrl: 'https://www.ionic.money/',
    },
    { aliases: { lendle: { chains: ['mantle'], title: 'Lendle' } }, homepageUrl: 'https://www.lendle.xyz/' },
    { aliases: { 'mach-finance': { chains: ['sonic'], title: 'MachFi' } }, homepageUrl: 'https://www.machfi.xyz/' },
    { aliases: { malda: { chains: ['linea'], title: 'Malda' } }, homepageUrl: 'https://malda.xyz/' },
    { aliases: { moonwell: { chains: ['moonbeam'], title: 'Moonwell' } }, homepageUrl: 'https://moonwell.fi/' },
    { aliases: { nerite: { chains: ['arbitrum'], title: 'Nerite' } }, homepageUrl: 'https://www.nerite.org/' },
    { aliases: { omega: { chains: ['mantle'], title: 'Omega' } }, homepageUrl: 'https://www.omega.xyz/' },
    { aliases: { orbit: { chains: ['blast'], title: 'Orbit Protocol' } }, homepageUrl: 'https://orbitlending.io/' },
    {
        aliases: { 'segment-finance': { chains: ['bob'], title: 'Segment Finance' } },
        homepageUrl: 'https://www.segment.finance/',
    },
    {
        aliases: {
            'silo-finance-v1-rdnt': {
                chains: ['arbitrum'],
                title: 'Silo Finance RDNT market',
                description: 'Only to be used for the RDNT market.',
            },
        },
        homepageUrl: 'https://app.silo.finance/',
    },
    { aliases: { stability: { chains: ['sonic'], title: 'Stability' } }, homepageUrl: 'https://stability.farm/' },
    { aliases: { stout: { chains: ['sonic'], title: 'Stout' } }, homepageUrl: 'https://stout.fi/' },
    { aliases: { takara: { chains: ['sei'], title: 'Takara Lend' } }, homepageUrl: 'https://takaralend.com/' },
    {
        aliases: { 'vicuna-finance': { chains: ['sonic'], title: 'Vicuna Finance' } },
        homepageUrl: 'https://vicunafinance.com/',
    },
    { aliases: { yei: { chains: ['sei'], title: 'Yei Finance' } }, homepageUrl: 'https://www.yei.finance/' },
    { aliases: { zerolend: { chains: ['zircuit'], title: 'ZeroLend' } }, homepageUrl: 'https://zerolend.xyz/' },
];
//# sourceMappingURL=dapps.js.map